var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNote2 = function SvgNote2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.533 3.042H6.467a3.73 3.73 0 0 0-3.725 3.725v7.842a3.734 3.734 0 0 0 3.725 3.725h7.058a3.73 3.73 0 0 0 3.725-3.725V6.767a3.716 3.716 0 0 0-3.717-3.725",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.958 1.667H8.042c-.867 0-1.575.7-1.575 1.567v.783c0 .867.7 1.567 1.566 1.567h3.925c.867 0 1.567-.7 1.567-1.567v-.783a1.56 1.56 0 0 0-1.567-1.567M12.108 13.016 10.9 11.808l1.167-1.167a.63.63 0 0 0 0-.883.63.63 0 0 0-.884 0l-1.166 1.167-1.209-1.209a.63.63 0 0 0-.883 0 .63.63 0 0 0 0 .884l1.208 1.208-1.241 1.242a.63.63 0 0 0 0 .883.62.62 0 0 0 .441.183.62.62 0 0 0 .442-.183l1.242-1.242 1.208 1.209a.62.62 0 0 0 .442.183.62.62 0 0 0 .441-.183.63.63 0 0 0 0-.884"
  })));
};
export default SvgNote2;